document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-quantity-wrapper]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="number"]');
    if (!input) return;

    wrapper.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.getAttribute('data-quantity-change'));
        const current = Number(input.value || 1);
        const min = Number(input.getAttribute('min') || 1);
        input.value = Math.max(min, current + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[role="tab"]');
    const panels = tabs.querySelectorAll('[role="tabpanel"]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('aria-controls');

        buttons.forEach((item) => {
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== target;
        });
      });
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-product-gallery]');
      const main = gallery && gallery.querySelector('[data-gallery-main]');
      const image = thumb.querySelector('img');
      if (!main || !image) return;

      main.innerHTML = '';
      const clone = image.cloneNode(true);
      clone.removeAttribute('loading');
      clone.removeAttribute('sizes');
      clone.removeAttribute('srcset');
      main.appendChild(clone);
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  document.querySelectorAll('[data-variant-selector]').forEach((selector) => {
    selector.addEventListener('change', () => {
      const option = selector.selectedOptions[0];
      const form = selector.closest('form');
      const scope = selector.closest('.pdp-info') || document;
      const price = scope.querySelector('[data-product-price]');
      const compare = scope.querySelector('[data-product-compare]');
      const save = scope.querySelector('[data-product-save]');
      const button = form && form.querySelector('[data-add-to-cart]');
      const buttonText = form && form.querySelector('[data-add-to-cart-text]');
      const available = option && option.dataset.available === 'true';

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (save) {
        save.textContent = option.dataset.save || '';
        save.hidden = !option.dataset.save;
      }
      if (button) button.disabled = !available;
      if (buttonText) buttonText.textContent = available ? 'Add to Cart' : 'Sold Out';
    });
  });

  document.querySelectorAll('[data-toast-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const toast = document.querySelector('[data-toast]');
      const message = toast && toast.querySelector('[data-toast-message]');
      if (!toast || !message) return;
      message.textContent = trigger.getAttribute('data-toast-trigger') || 'Done';
      toast.classList.add('show');
      window.clearTimeout(window.olernToastTimer);
      window.olernToastTimer = window.setTimeout(() => toast.classList.remove('show'), 2200);
    });
  });

  initCartAjax();
});

function formatMoney(cents, format) {
  if (cents == null || isNaN(cents)) return '';
  format = format || '${{amount}}';
  const value = (Math.abs(cents) / 100).toFixed(2);
  const parts = value.split('.');
  const whole = parts[0];
  const decimal = parts[1];
  const wholeWithCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const wholeWithDots = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const wholeWithApos = whole.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  const sign = cents < 0 ? '-' : '';
  return sign + format
    .replace(/\{\{\s*amount\s*\}\}/g, wholeWithCommas + '.' + decimal)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, wholeWithCommas)
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, wholeWithDots + ',' + decimal)
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, wholeWithDots)
    .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, wholeWithApos + '.' + decimal)
    .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + decimal);
}

function initCartAjax() {
  const forms = document.querySelectorAll('[data-cart-form]');
  if (!forms.length) return;

  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  forms.forEach((form) => {
    const moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
    const subtotalEl = form.querySelector('[data-cart-subtotal]');
    const overlay = form.querySelector('[data-cart-loading]');
    const updateBtn = form.querySelector('[data-cart-update-btn]');
    if (updateBtn) updateBtn.hidden = true;

    const timers = new Map();
    let pendingRequests = 0;

    function setLoading(row, on) {
      if (on) {
        pendingRequests++;
        form.classList.add('is-updating');
        if (overlay) overlay.hidden = false;
        if (row) row.classList.add('is-updating');
      } else {
        pendingRequests = Math.max(0, pendingRequests - 1);
        if (pendingRequests === 0) {
          form.classList.remove('is-updating');
          if (overlay) overlay.hidden = true;
        }
        if (row) row.classList.remove('is-updating');
      }
    }

    function scheduleUpdate(input, delay) {
      const key = input.getAttribute('data-line');
      if (timers.has(key)) clearTimeout(timers.get(key));
      timers.set(key, setTimeout(() => updateLine(input), delay));
    }

    function updateLine(input) {
      const line = Number(input.getAttribute('data-line'));
      const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
      const row = input.closest('tr');
      setLoading(row, true);

      fetch(cartRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
        .then(({ ok, data }) => {
          if (!ok || !data || !Array.isArray(data.items)) {
            throw new Error((data && data.description) || 'Cart update failed');
          }
          // 行被删除（数量=0）或购物车清空时刷新页面，因为行索引会变化
          if (quantity === 0 || data.item_count === 0) {
            window.location.reload();
            return;
          }
          // 更新每行的小计、数量
          data.items.forEach((item, index) => {
            const lineNum = index + 1;
            const tr = form.querySelector('tr[data-cart-line="' + lineNum + '"]');
            if (!tr) return;
            const priceCell = tr.querySelector('[data-cart-line-price]');
            if (priceCell) priceCell.textContent = formatMoney(item.final_line_price, moneyFormat);
            const qtyInput = tr.querySelector('[data-cart-quantity]');
            if (qtyInput && document.activeElement !== qtyInput && Number(qtyInput.value) !== item.quantity) {
              qtyInput.value = item.quantity;
            }
          });
          if (subtotalEl) subtotalEl.textContent = formatMoney(data.total_price, moneyFormat);
        })
        .catch((err) => {
          console.error('[cart] update failed:', err);
          window.location.reload();
        })
        .finally(() => {
          setLoading(row, false);
        });
    }

    form.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      input.addEventListener('change', () => scheduleUpdate(input, 0));
      input.addEventListener('input', () => scheduleUpdate(input, 600));
    });

    form.addEventListener('submit', (e) => {
      const submitter = e.submitter;
      // 让 checkout 按钮正常提交，update 按钮拦截
      if (submitter && submitter.name === 'checkout') return;
      e.preventDefault();
      form.querySelectorAll('[data-cart-quantity]').forEach((input) => updateLine(input));
    });
  });
}
